import React from 'react'
import { MuiGrid } from '../../../ui/MaterialUIComponents';
import IndividualTimeTableSchedule from './IndividualTimeTableSchedule'
import MasterSchedule from './MasterSchedule';
export default function TimeTableGridComponent(props) {

    let header = props.header
    let timeTable = props.timeTable;
    
    return (
        <MuiGrid container >

            {props.scheduleType == 'masterSchedule' ?
                <MasterSchedule  {...props}
                    header={header}
                    timeTable={timeTable}
                    timeTableForTeacher={props.timeTableForTeacher}
                    timeTableType={props.timeTableType} 
                    roomsTimeTable={props.roomsTimeTable}
                    height='64vh'
                    /> :
                header.length > 0 && <IndividualTimeTableSchedule
                    {...props}
                    header={header}
                    timeTableType={props.timeTableType}
                    timeTableForTeacher={props.timeTableForTeacher}
                    availableTeachersList={props.availableTeachersList}
                    timeTable={timeTable} roomsTimeTable={props.roomsTimeTable}/>

            }

        </MuiGrid>
    )

}
